/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["ui-select-card-group{width:100%;display:flex;flex-wrap:wrap;align-items:stretch;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}ui-select-card-group ui-select-card{display:flex;flex-grow:0;width:calc((100% + 16px)/ 5 - 16px);margin-right:16px;margin-bottom:16px}ui-select-card-group ui-select-card:nth-child(5n){margin-right:0}"];
export { styles as styles };
